/* This file is autogenerated, see readme.md for instructions */
import CustomerSvgIcon from '@bloomreach/banana-theme/icons/customer-.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CustomerIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CustomerSvgIcon />
    </Icon>
  );
});

CustomerIcon.displayName = 'CustomerIcon';

export default CustomerIcon;
